<template>
  <cumulus-info-dialog
    v-model="dialogInfo"
    icon="$info"
    :title="$t('operating_day_roles')"
    :max-width="400"
    color="primary"
    activator-button
    custom-class="mr-2"
    @open="showUserRoles"
    @escape="closeDialog"
  >
    <template v-slot:info>
      <v-list two-line>
        <v-list-item-group
          v-model="selected"
          active-class="blue--text"
        >
          <template v-for="(role) in userRoles">
            <v-list-item :key="role.operating_day_id" :disabled="false">
              <v-list-item-content>
                <v-list-item-title> {{ role.date | dateFormat }} </v-list-item-title>
                <v-list-item-subtitle> {{ $t('fields.'+role.role+'_id') }} </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn
                  :disabled="role.sr === 1"
                  color="primary"
                  small
                  @click="clickSubstitutionRequest(role)"
                >
                  {{ $t('substitution_request') }}
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </template>
  </cumulus-info-dialog>
</template>

<script>
  import { call, get } from 'vuex-pathify'

  export default {
    name: 'OperatingDayUserInformations',
    props: {
      operatingDay: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        dialogInfo: false,
        userRoles: [],
        selected: [],
      }
    },
    computed: {
      profile: get('auth/profile'),
    },
    methods: {
      getUserRoles: call('operatingDay/userRoles'),
      substitutionRequest: call('action/substitutionRequest'),
      async showUserRoles () {
        console.log('showUserStat')
        this.loading = true
        await this.getUserRoles().then(response => {
          this.userRoles = response
          this.dialogInfo = true
          this.loading = false
        }).catch(e => {
          this.loading = false
          console.log(e)
        })
      },
      closeDialog () {
        this.dialogInfo = false
      },
      async clickSubstitutionRequest (role) {
        console.log(role)
        await this.substitutionRequest(
          {
            role: role.role,
            requestor_id: this.profile.user_id,
            operating_day_id: role.operating_day_id,
          },
        ).then(response => {
          console.log('apply success')
          this.closeDialog()
        }).catch(e => {
          console.log(e)
          this.$refs.dialog.setErrors(e)
        })
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
    // max-height: calc(100vh - 500px)
</style>
